import { inject, Injectable, PLATFORM_ID, REQUEST } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly request = isPlatformServer(this.platformId) ? inject(REQUEST) : null;

  isDesktop(): boolean {
    if (isPlatformServer(this.platformId)) {
      const ua = this.request?.headers.get('user-agent') || '';
      return !/mobile|android|iphone|ipad/i.test(ua);
    }

    // En cliente
    return window.innerWidth >= 1024;
  }

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
}
